export const SELECT_COUNTRY = "SELECT_COUNTRY";
export const SET_PROVINCE_STATE = "SET_PROVINCE_STATE";
export const SET_CITY = "SET_CITY";
export const SET_ADDRESS = "SET_ADDRESS";
export const SET_POSTAL_CODE = "SET_POSTAL_CODE";
export const CLEAR_SHIPPING_INFO = "CLEAR_SHIPPING_INFO";

export function setCountry(country) {
    return {
        type: SELECT_COUNTRY,
        country
    }
}

export function setProvinceState(provinceState) {
    return {
        type: SET_PROVINCE_STATE,
        provinceState
    }
}

export function setCity(city) {
    return {
        type: SET_CITY,
        city
    }
}

export function setAddress(address) {
    return {
        type: SET_ADDRESS,
        address
    }
}

export function clearShippingInfo() {
    return {
        type: CLEAR_SHIPPING_INFO
    }
}

export function setPostalCode(postal_code) {
    return {
        type: SET_POSTAL_CODE,
        postal_code
    }
}